<div class="inline-flex items-center">
  <div class="button-wrapper--outer" cdbaInView>
    <div class="button-wrapper--inner">
      <cdba-load-bom-button [gridApi]="gridApi"></cdba-load-bom-button>
    </div>
  </div>
  <div class="button-wrapper--outer" cdbaInView>
    <div class="button-wrapper--inner flex items-center">
      <cdba-compare-button
        [comparableItems]="comparableItems"
      ></cdba-compare-button>
      @if (
        (numberOfUnauthorizedCalculations$ | ngrxPush) ||
        (missingCostRoles$ | ngrxPush)?.length
      ) {
        <cdba-excluded-calculations-button
          [numberOfUnauthorizedCalculations]="
            numberOfUnauthorizedCalculations$ | ngrxPush
          "
          [missingCostRoles]="missingCostRoles$ | ngrxPush"
          [unauthorizedPlants]="unauthorizedPlants$ | ngrxPush"
        ></cdba-excluded-calculations-button>
      }
    </div>
  </div>
</div>
